module.exports = __webpack_public_path__ + "02_sobakasu.a2b70928.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/mama/layer3/02_sobakasu.png
// module id = lOlG
// module chunks = 0